<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-fixed"
    :class="{
      [`md-${type}`]: !navbarTransparent,
      [extraNavClasses]: navbarTransparent,
      'md-transparent': navbarTransparent
    }"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ brand }}</h3>
      </div>
      <div class="md-toolbar-section-end">

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <md-list>
              
              <li class="md-list-item">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down direction="down">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple dropdown-toggle"
                        data-toggle="dropdown"
                      >
                      <!-- {{ $store.state.lang }} -->
                      <img :src="flag" /></md-button>
                      <ul class="dropdown-menu">
                        <li v-if="$store.state.lang !== 'AZ'">
                          <router-link to @click.native="onLang('AZ')"><img :src="azflag" /></router-link>
                        </li>
                        <li v-if="$store.state.lang !== 'EN'">
                          <router-link to @click.native="onLang('EN')"><img :src="enflag" /></router-link>
                        </li>
                        <li v-if="$store.state.lang !== 'RU'">
                          <router-link to @click.native="onLang('RU')"><img :src="ruflag" /></router-link>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import { AZ_Flag, RU_Flag, EN_Flag } from "../services/helper"
export default {
  components: {
    // MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
          "dark"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    navbarTransparent: {
      type: Boolean,
      default: false
    },
    id: String
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
      brand: "HU Menu",
      azflag: AZ_Flag,
      enflag: EN_Flag,
      ruflag: RU_Flag
    };
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["index"];
      return excludedRoutes.every(r => r !== this.$route.name);
    },
    flag() {
      return this.$store.state.lang === "RU" ? this.ruflag : this.$store.state.lang === "EN" ? this.enflag : this.azflag;
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
    this.$store.dispatch("loadOrder", this.id);
    this.$store.dispatch("loadInfo");
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
  methods: {
    onLang(lg) {
      this.$store.dispatch("setLang", lg);
      // this.$router.go();
      window.location.reload()
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    }
  },
  created(){
  }
};
</script>
